import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { JobCardPartialState } from './job-card.reducer';
import { jobCardQuery } from './job-card.selectors';
import {
  CreateJobCard,
  LoadAWBDetails,
  LoadFiles,
  LoadJobCard,
  LoadNextJobNo,
  LoadSelectedJobCard,
  SaveACDDetails,
  SaveAWBDetails,
  SaveEGLBLDetails,
  SaveLoadingConfirmationDetails,
  SaveStuffingDetails,
  SaveTVTBLDetails,
  UpdateAWBDetails,
  UpdateJObCard,
  UploadFiles,
} from './job-card.actions';

@Injectable()
export class JobCardFacade {
  loaded$ = this.store.pipe(select(jobCardQuery.getLoaded));
  allJobCard$ = this.store.pipe(select(jobCardQuery.getAllJobCard));
  selectedJobCard$ = this.store.pipe(select(jobCardQuery.getSelectedJobCard));
  loadSelectedJobCard$ = this.store.pipe(
    select(jobCardQuery.loadSelectedJobCard)
  );
  allNextJobNo$ = this.store.pipe(select(jobCardQuery.getAllNextJobNo));
  loading$ = this.store.pipe(select(jobCardQuery.getLoading));
  updateJobLoading$ = this.store.pipe(select(jobCardQuery.getUpdateJobLoading));
  stuffingDetails$ = this.store.pipe(select(jobCardQuery.getStuffingDetails));
  loadingConfirmationDetails$ = this.store.pipe(
    select(jobCardQuery.getLoadingConfirmationDetails)
  );
  tvtBLDetails$ = this.store.pipe(select(jobCardQuery.getTVTBLDetails));
  eglBLDetails$ = this.store.pipe(select(jobCardQuery.getEGLBLDetails));
  awbDetails$ = this.store.pipe(select(jobCardQuery.getAWBDetails));
  logoUrl$ = this.store.pipe(select(jobCardQuery.getLogoUrl));
  acdDetails$ = this.store.pipe(select(jobCardQuery.getACDDetails));
  files$ = this.store.pipe(select(jobCardQuery.getAllFiles));
  fileProgress$ = this.store.pipe(select(jobCardQuery.getFileProgress));
  loadFilesLoading$ = this.store.pipe(select(jobCardQuery.getLoadFilesLoading));

  constructor(private store: Store<JobCardPartialState>) {}

  loadAll(filter?: string, filterByMode?: string) {
    this.store.dispatch(new LoadJobCard(filter, filterByMode));
  }
  getSelectedJobCard(id: string, date: string) {
    this.store.dispatch(new LoadSelectedJobCard(id, date));
  }
  createJobCard(value: any) {
    this.store.dispatch(new CreateJobCard(value));
  }
  loadNextJobNo() {
    this.store.dispatch(new LoadNextJobNo());
  }
  updateJobCard(data: any, onTransfer?: boolean, email?: string) {
    this.store.dispatch(new UpdateJObCard(data, onTransfer, email));
  }
  saveStuffingDetails(data: any) {
    this.store.dispatch(new SaveStuffingDetails(data));
  }
  saveLoadingConfirmationDetails(data: any) {
    this.store.dispatch(new SaveLoadingConfirmationDetails(data));
  }
  saveTVTBLDetails(data: any) {
    this.store.dispatch(new SaveTVTBLDetails(data));
  }
  saveEGLBLDetails(data: any) {
    this.store.dispatch(new SaveEGLBLDetails(data));
  }
  saveAWBDetails(data: any, id?: string) {
    this.store.dispatch(new SaveAWBDetails(data, id));
  }
  saveACDDetails(data: any) {
    this.store.dispatch(new SaveACDDetails(data));
  }
  uploadFile(fileName: string, file: File) {
    this.store.dispatch(new UploadFiles(fileName, file));
  }
  loadFiles(prefix: string) {
    this.store.dispatch(new LoadFiles(prefix));
  }
  loadAWBDetails(id: string) {
    this.store.dispatch(new LoadAWBDetails(id));
  }
  updateAWBDetails(data: any) {
    this.store.dispatch(new UpdateAWBDetails(data));
  }
}
